import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=2f94cad4&"
import script from "./AddAsset.vue?vue&type=script&lang=js&"
export * from "./AddAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports